// Les dues formes dels bucles causals, i com es passa de l'una a l'altra.
//
// Viuen en un fitxer a part i **sense cap import** a posta: així es poden provar soles, sense
// muntar axios ni el navegador. La prova real fa la volta sencera —client → API → base → API →
// client— i comprova que no es perd res pel camí.
//
// El llenç i la base parlen llengües diferents, i **això és el que va deixar aquesta
// funcionalitat sense acabar des del 08/08/2026**. La base només accepta `positive`/`negative`,
// `weak`/`moderate`/`strong` i quatre tipus de variable que no inclouen `variable`; el llenç
// envia `'+'`, `'medium'` i `'variable'`. La traducció va aquí, com la dels components.
//
// L'altra diferència: mentre es dibuixa, els identificadors són un comptador del navegador
// («1», «2», «rel_1724…»), i les relacions hi apunten. En desar, la base assigna UUID i torna la
// correspondència; el llenç els adopta i a partir d'aquí ja parla d'UUID.
export const TIPUS_VARIABLE = { variable: 'auxiliary', auxiliary: 'auxiliary', stock: 'stock',
                         external: 'external', intervention: 'intervention' };
const FORCA_CAP_A_API = { weak: 'weak', medium: 'moderate', moderate: 'moderate', strong: 'strong' };
const FORCA_DES_DE_API = { weak: 'weak', moderate: 'medium', strong: 'strong' };

export const variableCapALAPI = (v) => ({
  clientId: String(v.id),
  name: v.name,
  description: v.description || '',
  type: TIPUS_VARIABLE[v.type] || 'auxiliary',
  x: Number(v.x) || 0,
  y: Number(v.y) || 0,
  // La polaritat d'una variable no té columna pròpia: va amb la resta de propietats.
  properties: { ...(v.properties || {}), polarity: v.polarity || '+' },
});

export const variableDesDeLAPI = (v) => ({
  id: v.id,
  name: v.name,
  description: v.description || '',
  type: 'variable',
  x: v.position?.x ?? 0,
  y: v.position?.y ?? 0,
  polarity: v.properties?.polarity || '+',
  properties: v.properties || {},
});

export const relacioCapALAPI = (r) => ({
  source: String(r.source),
  target: String(r.target),
  polarity: r.polarity === '-' ? 'negative' : 'positive',
  // Al llenç el retard és un número de passos; a la base són un booleà i un text.
  delay: Number(r.delay) > 0,
  delayDuration: Number(r.delay) > 0 ? String(r.delay) : null,
  strength: FORCA_CAP_A_API[r.strength] || 'moderate',
  // El nom i la descripció van a `properties`: la taula de relacions no en té columna.
  properties: { ...(r.properties || {}), name: r.name || '', description: r.description || '' },
});

export const relacioDesDeLAPI = (r) => ({
  id: r.id,
  // Que és un lligam es deia amb el prefix `rel_` de l'identificador provisional del navegador.
  // En tornar de la base l'identificador és un UUID i el prefix desapareix: **després del primer
  // desat, un lligam deixava de reconèixer-se com a tal** i ni s'editava ni s'esborrava. Ara ho
  // diu un camp, com les variables, que ja portaven `type: 'variable'`.
  type: 'relationship',
  source: r.sourceVariableId,
  target: r.targetVariableId,
  polarity: r.polarity === 'negative' ? '-' : '+',
  delay: r.delayDuration ? Number(r.delayDuration) : 0,
  strength: FORCA_DES_DE_API[r.strength] || 'medium',
  name: r.properties?.name || '',
  description: r.properties?.description || '',
  properties: r.properties || {},
});

